"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BuiltToSurviveTheEnvironment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="built-to-survive-the-environment" className="bg-background py-16 md:py-24">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="bg-card rounded-lg p-8 md:p-12 shadow-lg border border-border">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-card-foreground mb-6">
            Which Materials Survive a Substation Environment?
          </h2>
          
          <div className="space-y-6 text-lg text-muted-foreground font-default">
            <p>
              Outdoor utility identification is a materials decision first. Evermark Industrial Solutions specifies engraved stainless steel and anodized aluminum for substation and outdoor switchgear identification because the mark is engraved into the metal and the material resists UV, weather, and temperature for the long service life utility equipment demands.
            </p>
            <p>Indoor control rooms and protection panels can use engraved phenolic or acrylic where the environment is controlled. Evermark matches the material to each placement rather than using one material everywhere. Material durability ratings — UV, temperature, and expected outdoor life: </p>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-6">
            <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-primary/80 justify-start text-lg font-medium">
              
            </Button>
            <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-primary/80 justify-start text-lg font-medium">
              <Link to="/MaterialsPage">
                Compare all materials <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}